import { useState, useEffect, useRef } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SceneScreen from "@/components/SceneScreen";
import { SCENES } from "@/data/scenes";
import { track } from "@/lib/analytics";

export const Simulation = ({ onComplete, onHome, simId, sessionId }) => {
  const [index, setIndex] = useState(0);
  const [transcript, setTranscript] = useState([]);

  const sentStages = useRef(new Set());
  useEffect(() => {
    // Privacy-safe funnel: record ONLY the scene/stage identifier (no responses), once per stage
    const stage = `scene_${index + 1}`;
    if (!sentStages.current.has(stage)) {
      sentStages.current.add(stage);
      track("simulation_progress", stage, { simulation_id: simId, session_id: sessionId });
    }
  }, [index, simId, sessionId]);

  const handleSceneDone = (entry) => {
    const next = [...transcript, entry];
    setTranscript(next);
    if (index + 1 < SCENES.length) setIndex(index + 1);
    else onComplete(next);
  };

  const goBack = () => {
    if (index === 0) return;
    setTranscript((t) => t.slice(0, -1));
    setIndex(index - 1);
  };

  const scene = SCENES[index];

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={scene.id}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0"
      >
        <SceneScreen
          scene={scene}
          sceneIndex={index}
          total={SCENES.length}
          onSceneDone={handleSceneDone}
          onHome={onHome}
          onBack={index > 0 ? goBack : undefined}
        />
      </motion.div>
    </AnimatePresence>
  );
};

export default Simulation;
